<template>
  <div id="le_tp_wrapper" ref="le_tp_wrapper" class="le-tp-wrapper" :class="{'le-tp-wrapper-border':options.showBorder}">
    <div class="le-tp-container le-flex-column">
      <le-tp-header v-if="!readonly" :tp-context.sync="tpStore" :tp-config.sync="tpOptions" @click="handleHeaderBtnClickEvent" />

      <div class="le-tp-body">
        <le-tp-aside v-if="!readonly" :tp-context.sync="tpStore" :tp-config.sync="tpOptions" @click="handleClickEvent" />

        <div class="le-tp-main">
          <div id="le_tp_canvas" ref="le_tp_canvas" class="le-tp-canvas" @drop.stop.prevent="handleDropAddShapeEvent" @dragover.prevent />

          <le-tp-zoom :tp-context.sync="tpStore" />
        </div>

        <le-tp-attribute v-if="!readonly" :tp-context.sync="tpStore" :tp-config.sync="tpOptions" />
      </div>
    </div>

    <div class="le-tp-job-wrapper">
      <!-- 监视器列表 -->
      <le-tp-job :visible.sync="jobDialogVisible" :element-identity="elementIdentity" />
    </div>

    <div class="le-tp-line-wrapper">
      <le-tp-line-info ref="leTpLineInfo" />

      <le-tp-job-info ref="leTpJobInfo" />
    </div>

    <div class="le-tp-line-relation">
      <le-tp-job-line-relation ref="leTpLineRelation" :tp-context.sync="tpStore" />
    </div>
  </div>
</template>

<script>
import LeTpHeader from './components/layout/le_tp_header';
import LeTpAside from './components/layout/le_tp_aside';
import LeTpAttribute from './components/layout/le_tp_attribute';
import LeTpJob from './components/info/le_tp_job';
import LeTpJobInfo from './components/info/le_tp_job_info';
import LeTpLineInfo from './components/info/le_tp_line_info';
import LeTpJobLineRelation from './components/info/le_tp_job_line_relation';
import LeTpZoom from './components/parts/le_tp_zoom';
import {commonMixins, graphMixins} from './scripts/mixins';
import {elementFullScreen} from '../../static/scripts/util/third_util';
import {handleHeaderButtonClickEvent} from './scripts/core/logic/logic';

export default {
  name: 'LeTopology',
  components: {LeTpJobInfo, LeTpZoom, LeTpJobLineRelation, LeTpLineInfo, LeTpJob, LeTpAttribute, LeTpAside, LeTpHeader},
  mixins: [graphMixins, commonMixins],
  props: {
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    options: {
      type: Object,
      required: false,
      default() {
        return {
          // 是否显示边框
          showBorder: true
        };
      }
    },
    tpData: {
      type: Object,
      required: false,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      jobDialogVisible: false,
      elementIdentity: ''
    };
  },
  created() {
    this.$nextTick(() => {
      // 初始化自定义事件
      this.initCustomGlobalEvent();
    });
  },
  destroyed() {
    // 销毁自定义全局事件
    this.$bus.$off();
  },
  methods: {
    initCustomGlobalEvent() {
      // 初始化自定义事件
      this.$bus.$on('tp:aside:tabsChangeShowDialog', this.handleJobDialogShowOrHide);
    },
    handleJobDialogShowOrHide(status, elementIdentity) {
      // 控制监视器列表显示隐藏
      this.jobDialogVisible = status || false;
      this.elementIdentity = elementIdentity;
    },
    handleHeaderBtnClickEvent(command) {
      // 处理顶部按钮点击事件
      handleHeaderButtonClickEvent(this, command);
    },
    handleDropAddShapeEvent(evt) {
      // 处理图形生成渲染事件
      // handleDropAddShapeEvent(this, evt);
      this.getCanvasStage().emit('custom:editor:addNode', {that: this, evt: evt});

      // 阻止事件冒泡和默认行为
      evt.preventDefault();
    },
    handleClickEvent(ele) {
      // 处理左侧组件点击事件
      // handleDrawShapeEvent(this, ele?.id);
    },



    handleNodeClickEvent(node) {
      console.log('回调对外暴露节点单击事件', node);
      // 对外暴露节点单击事件
      this.$emit('nodeClickEvent', node);
    },
    handleNodeDblclickEvent(node) {
      console.log('回调对外暴露节点双击事件', node);
      // 对外暴露节点双击事件
      this.$emit('nodeDblclickEvent', node);
    },
    handleNodeMouseOverEvent(node) {
      // 对外暴露节点鼠标悬停事件
      this.$emit('nodeMouseOverEvent', node);
    },
    handleFullScreenEvent() {
      // 指定全屏区域元素
      elementFullScreen('le_tp_wrapper');
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
